<template>
  <section class="landing-github">

    <div class="inner-container">

      <h2 class="section-title">
        Projetos que desenvolvemos
      </h2>

      <ul class="repo-list ">
        <li class=" repo-item" v-for="(repo, index) in firstSixReposByStar">
          <h3>
            {{repo.full_name.replace('moip/', '').replace(/-/g, ' ')}}
          </h3>
          <p class="repo-rating">
            <span class="moip-icon moip-icon-code-fork"></span>
            {{repo.forks_count}}
            <span class="moip-icon moip-icon-star"></span>
            {{repo.stargazers_count}}
          </p>
          <!-- <p class="repo-description">
            {{repo.description}}
          </p> -->
          <round-button href="https://github.com/moip" target="_blank" class="purple show-project">
            <span class="moip-icon moip-icon-github"></span>
            Ver projeto
          </round-button>
        </li>
      </ul>
    </div>
    
    <!-- <p class="text-center center-text">
      <round-button href="https://github.com/moip" class="purple show-more">
        <span class="moip-icon moip-icon-github"></span>
        Ver mais
      </round-button>
    </p> -->
  
  </section>  
</template>

<style lang="less">
  @import (reference) '../assets/styles/references';

  .landing-github{
    background: @gray-2;
    padding: @xs-spacer 0 (@md-spacer + @xs-spacer);
    border-radius: @xs-spacer/2;
    margin: @sm-spacer;
    .section-title{
      color: @purple-2;
      text-align: center;
      font-weight: @font-weight-regular;
      &::after{
        display: none;
      }
    }
    .inner-container{
      overflow: hidden;
    }
    .show-more,
    .show-project{
      display: block;
      text-align: center;
      padding: 0 20px;
      span{
        padding-right: @xs-spacer;
        font-size: 18px;
      }
    }
    .show-project {
      width: 200px;
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translate(-50%, 0) !important;
    }

  }
  .repo-list{
    list-style: none;
    float: left;
    display: flex;
    flex-wrap: wrap;
    
    h3{
      font-size: 22px;
      color: @dark-blue;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 1em;
      text-transform: uppercase;
      padding-bottom: 20px;
      border-bottom: solid 1px #BFC6DB;
    }
    
    .repo-rating{
      font-size: 24px;
    }
    .moip-icon-code-fork {
      color: #09BFD9;
    }
    .moip-icon-star {
      color: @yellow;
    }

    .repo-item{
      position: relative;
      height: 190px;
      width: 280px;
      background-color: @white;
      border-radius: @xs-spacer/2;
      margin: @sm-spacer @xs-spacer;
      float: left;
      box-sizing: border-box;
      padding: @xs-spacer @sm-spacer;
    }
  }
</style>

<script>
  import RoundButton from './RoundButton'

  export default {

    data() {
      return {
        repos: [],
        repos_length: '',
        showMore: false
      }
    },
    components: {
      RoundButton
    },
    computed: {
      firstSixReposByStar() {
        return this.repos.slice(0, 6);
      }
    },
    mounted: function() {
      let gitHubApi = 'https://api.github.com/orgs/moip/repos?per_page=50'
      this.$http.get(gitHubApi).then((response) => {
        this.repos = response.body
        this.repos.sort(function (a, b) {
          return b.stargazers_count - a.stargazers_count
        });
        this.repos_length = this.repos_length
      }, (errorResponse) => {
        console.log(errorResponse)
      });
    }
  }
</script>



// WEBPACK FOOTER //
// LandingGithub.vue?1091be64